import {
  Button,
  Modal,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  ModalBody,
  ModalHeader,
  Text,
  VStack,
  Input,
  HStack,
  useToast,
  Spinner,
  Image,
  Box,
  Heading,
  SimpleGrid,
  Flex,
  Icon,
  FormControl,
  FormLabel,
  InputGroup,
  InputLeftElement,
  useColorModeValue,
} from "@chakra-ui/react";
import React, { useContext, useState, useEffect } from "react";
import { AppContext } from "../../../context/AppContext";
import {
  EditCurrency,
  EditUpi,
  GetAdminAllCurrency,
  GetUPI,
} from "../../../utils/api";
import Empty from "../../../components/Empty";
import { FiEdit2, FiDollarSign, FiImage, FiHash, FiCreditCard } from "react-icons/fi";
import trxIcon from '../../../assets/trx.png';
import usdtIcon from '../../../assets/tether.png';

const Currency = () => {
  const { AdminToken } = useContext(AppContext);

  const toast = useToast();

  // Colors
  const cardBg = "gray.800";
  const textColor = "white";
  const subTextColor = "gray.400";
  const borderColor = "gray.700";
  const themeColor = "#319795";

  // Currencies
  const [currencies, setCurrencies] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currencyId, setCurrencyId] = useState("");
  const [editModal, setEditModal] = useState(false);
  const [currentCurrency, setCurrentCurrency] = useState({
    currencyName: "",
    currencyPrice: "",
    color: "#000000",
    imgUrl: "",
  });

  // UPI
  const [upiModal, setUpiModal] = useState(false);
  const [upiData, setUpiData] = useState({});
  const [upiForm, setUpiForm] = useState({
    Token: "",
    upiId: "",
    imgURL: "",

  });

  // Fetch Data
  useEffect(() => {
    setLoading(false);

    Promise.all([GetUPI(AdminToken), GetAdminAllCurrency(AdminToken)])
      .then(([upiRes, currencyRes]) => {
        setUpiData(upiRes.data.data);
        setUpiForm(upiRes.data.data);
        setCurrencies(currencyRes.data.currencies);
        setLoading(true);
      })
      .catch((err) => {
        console.error("Error fetching:", err);
        setLoading(true);
      });
  }, [AdminToken]);



  // Edit Currency
  const handleEditCurrency = (e) => {
    e.preventDefault();

    EditCurrency(currencyId, currentCurrency, AdminToken)
      .then((res) => {
        toast({
          title: "Currency updated successfully",
          status: "success",
          duration: 3000,
          isClosable: true,
        });

        setCurrencies((prev) =>
          prev.map((c) => (c._id === currencyId ? { ...c, ...currentCurrency } : c))
        );
        setEditModal(false);
      })
      .catch((err) => {
        toast({
          title: err.response?.data?.message || err.message,
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      });
  };

  const openEditModal = (id, currency) => {
    setCurrencyId(id);
    setCurrentCurrency(currency);
    setEditModal(true);
  };

  // Update UPI
  const handleUpiUpdate = (e) => {
    e.preventDefault();

    const { Token, upiId, imgURL } = upiForm;

    if (!Token || !upiId || !imgURL) {
      return toast({
        title: "Please fill all UPI fields",
        status: "warning",
        duration: 3000,
        isClosable: true,
      });
    }

    EditUpi(AdminToken, upiForm)
      .then(() => {
        toast({
          title: "UPI Updated Successfully",
          status: "success",
          duration: 3000,
          isClosable: true,
        });
        setUpiData(upiForm);
        setUpiModal(false);
      })
      .catch((err) => {
        toast({
          title: err.response?.data?.message || err.message,
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      });
  };



  return (
    <Box p={[4, 6]} w="full" minH="100vh">
      <VStack spacing={8} align="stretch">
        {/* Header */}
        <Flex justify="space-between" align="center" wrap="wrap" gap={4}>
          <Box>
            <Heading size="lg" color={textColor}>Payment Settings</Heading>
            <Text color={subTextColor}>Manage UPI details and Currency packages</Text>
          </Box>
          <HStack spacing={4}>
            <Button
              leftIcon={<FiEdit2 />}
              onClick={() => setUpiModal(true)}
              bg={themeColor}
              color="white"
              _hover={{ bg: "teal.600" }}
              size="md"
            >
              Edit UPI
            </Button>

          </HStack>
        </Flex>

        {/* UPI Section */}
        <Box bg={cardBg} p={6} borderRadius="lg" boxShadow="sm" borderWidth="1px" borderColor={borderColor}>
          <Flex justify="space-between" align="center" mb={6}>
            <Heading size="md" color={textColor}>UPI Configuration</Heading>
          </Flex>

          <SimpleGrid columns={[1, 1, 1]} spacing={8}>
            {/* BharatPe Details */}
            <Box p={4} borderRadius="md" bg="gray.700" borderWidth="1px" borderColor={borderColor}>
              <Flex align="center" mb={4} gap={2}>
                <Icon as={FiCreditCard} color="green.500" />
                <Text fontWeight="bold" color={textColor}>BharatPe Details</Text>
              </Flex>
              <HStack align="start" spacing={4}>
                <Image
                  src={upiData?.imgURL}
                  alt="Bharat QR"
                  boxSize="100px"
                  objectFit="contain"
                  borderRadius="md"
                  bg="white"
                  borderWidth="1px"
                />
                <VStack align="start" spacing={1} flex={1}>
                  <Text fontSize="xs" color="gray.500">UPI ID</Text>
                  <Text fontWeight="medium" fontSize="sm" wordBreak="break-all" color={textColor}>{upiData?.upiId || "Not Set"}</Text>
                  <Text fontSize="xs" color="gray.500" mt={2}>Token</Text>
                  <Text fontWeight="medium" fontSize="sm" wordBreak="break-all" color={textColor}>{upiData?.Token || "Not Set"}</Text>
                </VStack>
              </HStack>
            </Box>


          </SimpleGrid>
        </Box>

        {/* Currencies Section */}
        <Box>
          <Heading size="md" color={textColor} mb={4}>Currency Packages</Heading>
          {!loading ? (
            <Flex justify="center" py={10}>
              <Spinner size="xl" color={themeColor} thickness="4px" />
            </Flex>
          ) : currencies.length ? (
            <SimpleGrid columns={[1, 2, 3, 4]} spacing={6}>
              {currencies.map((c) => (
                <Box
                  key={c._id}
                  bg={cardBg}
                  borderRadius="lg"
                  boxShadow="sm"
                  borderWidth="1px"
                  borderColor={borderColor}
                  overflow="hidden"
                  transition="all 0.2s"
                  _hover={{ transform: "translateY(-4px)", boxShadow: "md" }}
                >
                  <Box h="140px" bg={c.color || "gray.100"} position="relative" display="flex" alignItems="center" justifyContent="center">

                    <Image src={c.currencyName == 'TRX' ? trxIcon : usdtIcon} alt={c.currencyName} maxH="80%" maxW="80%" objectFit="contain" />
                    <Button
                      size="sm"
                      position="absolute"
                      top={2}
                      right={2}
                      bg="whiteAlpha.900"
                      _hover={{ bg: "white" }}
                      onClick={() => openEditModal(c._id, c)}
                      leftIcon={<FiEdit2 />}
                    >
                      Edit
                    </Button>
                  </Box>
                  <Box p={4}>
                    <Text fontWeight="bold" fontSize="lg" mb={1}>{c.currencyName}</Text>
                    <Text color={themeColor} fontWeight="bold" fontSize="xl">₹{c.currencyPrice}</Text>
                  </Box>
                </Box>
              ))}
            </SimpleGrid>
          ) : (
            <Empty title="No currencies found!" />
          )}
        </Box>
      </VStack>

      {/* UPI Edit Modal */}
      <Modal isOpen={upiModal} onClose={() => setUpiModal(false)} size="xl">
        <ModalOverlay />
        <ModalContent bg="gray.800" color="white">
          <ModalHeader>Update UPI Details</ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={6}>
            <form onSubmit={handleUpiUpdate}>
              <VStack spacing={4}>
                <FormControl>
                  <FormLabel>BharatPe UPI ID</FormLabel>
                  <InputGroup>
                    <InputLeftElement children={<FiHash color="gray.500" />} />
                    <Input
                      placeholder="Enter BharatPe UPI ID"
                      value={upiForm.upiId}
                      onChange={(e) => setUpiForm({ ...upiForm, upiId: e.target.value })}
                    />
                  </InputGroup>
                </FormControl>

                <FormControl>
                  <FormLabel>Token</FormLabel>
                  <InputGroup>
                    <InputLeftElement children={<FiHash color="gray.500" />} />
                    <Input
                      placeholder="Enter Token"
                      value={upiForm.Token}
                      onChange={(e) => setUpiForm({ ...upiForm, Token: e.target.value })}
                    />
                  </InputGroup>
                </FormControl>

                <FormControl>
                  <FormLabel>BharatPe QR URL</FormLabel>
                  <InputGroup>
                    <InputLeftElement children={<FiImage color="gray.500" />} />
                    <Input
                      placeholder="Enter Image URL"
                      value={upiForm.imgURL}
                      onChange={(e) => setUpiForm({ ...upiForm, imgURL: e.target.value })}
                    />
                  </InputGroup>
                  {upiForm.imgURL && (
                    <Image src={upiForm.imgURL} h="60px" mt={2} borderRadius="md" border="1px solid #eee" />
                  )}
                </FormControl>



                <Button type="submit" bg={themeColor} color="white" _hover={{ bg: "teal.600" }} w="full" mt={4}>
                  Update UPI Details
                </Button>
              </VStack>
            </form>
          </ModalBody>
        </ModalContent>
      </Modal>

      {/* Currency Edit Modal */}
      <Modal isOpen={editModal} onClose={() => setEditModal(false)}>
        <ModalOverlay />
        <ModalContent bg="gray.800" color="white">
          <ModalHeader>Edit Currency</ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={6}>
            <form onSubmit={handleEditCurrency}>
              <VStack spacing={4}>
                <FormControl isRequired>
                  <FormLabel>Currency Name</FormLabel>
                  <Input
                    placeholder="e.g. Gold Package"
                    value={currentCurrency.currencyName}
                    onChange={(e) => setCurrentCurrency({ ...currentCurrency, currencyName: e.target.value })}
                  />
                </FormControl>

                <FormControl isRequired>
                  <FormLabel>Price (₹)</FormLabel>
                  <InputGroup>
                    <InputLeftElement children={<Text color="gray.500">₹</Text>} />
                    <Input
                      type="number"
                      placeholder="e.g. 500"
                      value={currentCurrency.currencyPrice}
                      onChange={(e) => setCurrentCurrency({ ...currentCurrency, currencyPrice: e.target.value })}
                    />
                  </InputGroup>
                </FormControl>

                <FormControl>
                  <FormLabel>Background Color</FormLabel>
                  <HStack>
                    <Input
                      type="color"
                      w="50px"
                      p={1}
                      value={currentCurrency.color}
                      onChange={(e) => setCurrentCurrency({ ...currentCurrency, color: e.target.value })}
                    />
                    <Input
                      value={currentCurrency.color}
                      onChange={(e) => setCurrentCurrency({ ...currentCurrency, color: e.target.value })}
                      placeholder="#000000"
                    />
                  </HStack>
                </FormControl>

                <Button type="submit" bg={themeColor} color="white" _hover={{ bg: "teal.600" }} w="full" mt={4}>
                  Save Changes
                </Button>
              </VStack>
            </form>
          </ModalBody>
        </ModalContent>
      </Modal>
    </Box>
  );
};

export default Currency;